import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;

  span {
    color: ${(props) => props.theme.color.neutral.white};
    font-size: ${(props) => props.theme.font.textxl};
    font-weight: 400;
  }
`
